import React, { Component } from "react";
import { connect } from "react-redux";
import RaisedButton from "material-ui/RaisedButton";
import TextField from "material-ui/TextField";
import ImageList from "./ImageList";
import {
  Card,
  CardTitle,
  CardText,
  CardHeader,
  CardActions
} from "material-ui/Card";
import FileIcon from "material-ui/svg-icons/file/file-upload";

import {
  updateRoom,
  getAccomodationRooms,
  updateImage,
  deleteRoomImage,
  reorderRoomImages,
  importAccomodationRooms,
  deleteAccomodationRooms
} from "./actions";
import Flags from "./Flags";

import "../common.css";
import "./Accomodation.css";

class AccomodationRooms extends Component {
  state = { othyssia: "", rooms: [] };

  componentDidMount() {
    const { rooms, othyssia } = this.props;
    if (rooms !== undefined && rooms.length > 0) {
      this.setState({ rooms });
    }
    if (othyssia !== undefined && othyssia.length > 0) {
      this.setState({ othyssia });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { rooms } = this.props;
    const updateState =
      (prevProps.rooms === undefined && rooms !== undefined) ||
      (prevProps.rooms.length === 0 && rooms.length !== 0) ||
      (prevProps.rooms.length !== 0 && rooms.length === 0) ||
      (prevProps.rooms !== undefined &&
        rooms !== undefined &&
        prevProps.rooms.length > 0 &&
        rooms.length > 0 &&
        (prevProps.rooms.length !== rooms.length ||
          prevProps.rooms[0].lang !== this.props.rooms[0].lang ||
          prevProps.rooms.reduce((acc, room, roomIndex) => {
            return acc || room.images.length !== rooms[roomIndex].images.length;
          }, false) ||
          prevProps.rooms.reduce((acc, room, roomIndex) => {
            return (
              acc ||
              room.images.reduce((acc2, image, imageIndex) => {
                const matchingImage = rooms[roomIndex].images[imageIndex];
                return (
                  acc2 ||
                  image.id !== matchingImage.id ||
                  image.order !== matchingImage.order
                );
              }, false)
            );
          }, false)));
    if (updateState) {
      this.setState({ rooms });
    }
  }

  handleUpload = roomId => e => {
    setTimeout(() => {
      document.getElementById(`room-uploader-${roomId}`).click();
    }, 400);
  };

  handleFileUpload = roomId => e => {
    const file = e.target.files[0];
    const formData = new FormData();
    const code = this.props.merchantCode;
    const lang = this.props.lang;
    formData.append("file", file);
    const xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      `/api/merchants/${code}/addRoomImage/${roomId}/${lang}`,
      true
    );
    const that = this;
    xhr.onreadystatechange = function() {
      if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
        that.props.getAccomodationRooms(code, lang);
      }
    };
    xhr.send(formData);
  };

  renderImageUploader = roomId => {
    return (
      <div className="image-uploader-container">
        <RaisedButton
          className="image-uploader-btn"
          secondary
          label="Ajouter une image"
          icon={<FileIcon />}
          onClick={this.handleUpload(roomId)}
        />
        <div className="file-wrapper">
          <input
            type="file"
            id={`room-uploader-${roomId}`}
            onChange={this.handleFileUpload(roomId)}
          />
        </div>
      </div>
    );
  };

  deleteImage = roomId => imageId => () => {
    const { merchantCode, lang } = this.props;
    this.props.deleteImage(merchantCode, roomId, imageId, lang);
  };

  updateImage = (imageId, title, altText, facet) => {
    const { merchantCode, lang } = this.props;
    this.props.updateImage(merchantCode, imageId, title, altText, facet, lang);
  };

  reorderImages = roomId => images => {
    const { merchantCode, lang } = this.props;
    this.props.reorderImages(merchantCode, roomId, images, lang);
  };

  renderRoomImages = (roomId, images) => {
    const tiles = images.map(image => {
      return {
        id: image.id,
        image: image.medium,
        title: image.title,
        alt: image.alt,
        order: image.order,
        facet: image.facet
      };
    });
    return images !== undefined && images.length > 0 ? (
      <div>
        <ImageList
          title="Les images "
          images={tiles}
          updateCallback={this.updateImage}
          deleteCallback={this.deleteImage(roomId)}
          reorderCallback={this.reorderImages(roomId)}
        />
      </div>
    ) : null;
  };

  handleSubmit = roomId => e => {
    e.preventDefault();
    const { merchantCode, lang } = this.props;
    const room = this.state.rooms.filter(room => room.id === roomId);
    if (room.length === 1) {
      const { libelle, capacity, description } = room[0];
      this.props.updateRoom(
        merchantCode,
        roomId,
        libelle,
        capacity,
        description,
        lang
      );
    }
  };

  findRoomIndexByCode = (rooms, roomId) => {
    const possibleRoom = rooms
      .map((room, index) => {
        return Object.assign({}, room, { index });
      })
      .filter(room => {
        return room.id === roomId;
      });
    return possibleRoom.length === 1 ? possibleRoom[0].index : -1;
  };

  changeRoomProperty = (roomId, propertyName, value) => {
    const { rooms } = this.state;
    const roomIndex = this.findRoomIndexByCode(rooms, roomId);
    if (roomIndex !== -1) {
      const room = rooms[roomIndex];
      room[propertyName] = value;
      this.setState({
        rooms: [
          ...rooms.slice(0, roomIndex),
          room,
          ...rooms.slice(roomIndex + 1)
        ]
      });
    }
  };

  changeLibelle = roomId => (e, value) => {
    this.changeRoomProperty(roomId, "libelle", value);
  };

  changeCapacity = roomId => (e, value) => {
    this.changeRoomProperty(roomId, "capacity", value);
  };

  changeDescription = roomId => (e, value) => {
    this.changeRoomProperty(roomId, "description", value);
  };

  // changeFacet = roomId => (e, value) => {
  //   this.changeRoomProperty(roomId, 'facet', value)
  // }

  renderRoom = room => {
    const { id, libelle, type, capacity, description, images } = room;
    return (
      <Card expandable={true} className="secondaryCard">
        <CardHeader
          className={"secondaryCard--header"}
          title={`${libelle} (${type})`}
          subtitle={""}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardText className="cardText" expandable={true}>
          <div>
            <form onSubmit={this.handleSubmit(id)}>
              <div className="fieldset">
                <TextField
                  floatingLabelText="Nom de la chambre"
                  value={libelle ? libelle : ""}
                  onChange={this.changeLibelle(id)}
                />
                <TextField
                  floatingLabelText="Capacité"
                  value={capacity}
                  onChange={this.changeCapacity(id)}
                />
              </div>
              <div className="fieldset">
                <TextField
                  floatingLabelText="Description de la chambre"
                  value={description ? description : ""}
                  onChange={this.changeDescription(id)}
                  multiLine={true}
                  rows={3}
                  textareaStyle={{ backgroundColor: "#fafafa" }}
                  fullWidth
                />
              </div>
              <RaisedButton
                type="submit"
                secondary
                className="form-validate-btn"
                label="Valider"
              />
            </form>
          </div>
          <div className="room-image-block">
            {this.renderRoomImages(id, images)}
            {this.renderImageUploader(id)}
          </div>
        </CardText>
      </Card>
    );
  };

  changeOthyssiaCode = (e, othyssia) => {
    this.setState({ othyssia });
  };

  importAccomodationRooms = () => {
    this.props.importAccomodationRooms(
      this.props.merchantCode,
      this.props.lang,
      this.state.othyssia
    );
  };

  renderOthyssiaCodeForm = () => {
    const { othyssia } = this.state;
    return (
      <div>
        <Card className="secondaryCard">
          <CardTitle
            className={"secondaryCard--title"}
            title={<Flags prevText="Paramétrage Othyssia" />}
            subtitle={
              "Veuillez saisir le code Othyssia correspondant à cet hébergement et validez pour importer les chambres paramétrées"
            }
          />
          <CardText>
            <div className="import-room-container">
              <TextField
                name="othyssia"
                value={othyssia}
                onChange={this.changeOthyssiaCode}
                floatingLabelText="Code Othyssia"
                style={{ width: "40%" }}
              />
              <RaisedButton
                className="import-config-btn"
                label="Importer"
                secondary
                onClick={this.importAccomodationRooms}
              />
            </div>
          </CardText>
        </Card>
      </div>
    );
  };

  deleteAccomodationRooms = () => {
    const { deleteAccomodationRooms, merchantCode, lang } = this.props;
    deleteAccomodationRooms(merchantCode, lang);
  };

  renderRooms = () => {
    const { rooms } = this.state;
    return rooms && rooms.length > 0 ? (
      <div>
        <Card className="secondaryCard">
          <CardTitle
            className={"secondaryCard--title"}
            title={<Flags prevText="Les chambres " />}
            subtitle={
              "Modifiez les informations et les images des chambres disponibles"
            }
          />
          <CardActions>
            <RaisedButton
              secondary
              className="delete-room-btn"
              label={"Supprimer les chambres configurées"}
              onClick={this.deleteAccomodationRooms}
            />
          </CardActions>
        </Card>
        {rooms.map(room => {
          return <div key={room.id}>{this.renderRoom(room)}</div>;
        })}
      </div>
    ) : null;
  };

  render() {
    return (
      <div>
        {this.renderOthyssiaCodeForm()}
        {this.renderRooms()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  merchantCode: state.merchant.detail.code,
  rooms: state.accomodation.rooms,
  lang: state.accomodation.lang
});

const mapDispatchToProps = dispatch => ({
  updateRoom: (merchantCode, roomId, libelle, capacity, description, lang) => {
    dispatch(
      updateRoom(merchantCode, roomId, libelle, capacity, description, lang)
    );
  },
  getAccomodationRooms: (merchantCode, lang) => {
    dispatch(getAccomodationRooms(merchantCode, lang));
  },
  updateImage: (merchantCode, imageId, title, altText, facet, lang) => {
    dispatch(updateImage(merchantCode, imageId, title, altText, facet, lang));
  },
  deleteImage: (merchantCode, roomId, imageCode, lang) => {
    dispatch(deleteRoomImage(merchantCode, roomId, imageCode, lang));
  },
  reorderImages: (merchantCode, roomId, images, lang) => {
    dispatch(reorderRoomImages(merchantCode, roomId, images, lang));
  },
  importAccomodationRooms: (merchantCode, lang, othyssia) => {
    dispatch(importAccomodationRooms(merchantCode, lang, othyssia));
  },
  deleteAccomodationRooms: (merchantCode, lang) => {
    dispatch(deleteAccomodationRooms(merchantCode, lang));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccomodationRooms);



// WEBPACK FOOTER //
// ./src/merchant/accomodation/AccomodationRooms.js